export const THEME_KEY = "wecrew_console_theme";

export function readTheme(storage) {
  try {
    return storage?.getItem(THEME_KEY) === "light" ? "light" : "dark";
  } catch {
    return "dark";
  }
}

export function saveTheme(storage, theme) {
  try { storage?.setItem(THEME_KEY, theme); } catch { /* Theme still works in memory. */ }
}
